import React from 'react'
import { redData } from '../../../data/redirect.data'

import arrow from './../../../UI/general/arrow.svg'
import background from './../../../UI/general/background-red.webp'

interface Props{
    handleOpenRedirection: any
    openRedirectionBar: boolean
    selectedBike: any
}

interface State{}

class Redirection extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    componentDidUpdate(){
        console.log(this.props.selectedBike.Nombre)
    }

    render(): React.ReactNode {
        return(
            this.props.selectedBike && this.props.selectedBike.Nombre ?
            <div className={this.props.selectedBike && this.props.selectedBike.Nombre && this.props.openRedirectionBar? 'redirection-main':'redirection-main-closed'}>
                <div 
                    className={this.props.selectedBike && this.props.selectedBike.Nombre && this.props.openRedirectionBar ? 'collapsed-redirection-btn':'collapsed-redirection-btn-closed'} 
                    onClick={() => {this.props.handleOpenRedirection()}}
                >
                    <img src={arrow}/>
                </div>
                <div className={this.props.selectedBike && this.props.selectedBike.Nombre && this.props.openRedirectionBar ? 'collapsed-redirection-info fade-in':'collapsed-redirection-info fade-out'} >
                    <img src={background}/>
                    <div className='red-info-container'>
                        <div className='red-info-title-container'>
                            <div className='red-info-title-inner'>ATRÉVETE</div>
                        </div>
                        <div className='red-info-subtitle-container'>
                            <div className='red-info-title-inner'>A CONOCER MÁS</div>
                        </div>
                        <div className='info-text-container'>
                            Obtén más información sobre esta motocicleta ingresando al link. <br/><br/> Continúa tu proceso de compra con el formulario que hemos preparado para tí.
                        </div>
                        <a href={redData()[0][this.props.selectedBike.Nombre]} target={"_blank"}>
                            <div className='info-red-btn'>
                                ¡Quiero saber más!
                            </div>
                        </a>
                    </div>
                </div>
            </div>:<div></div>
        )
    }
}

export default Redirection